import { render, staticRenderFns } from "./targetAgainstUserTabs.vue?vue&type=template&id=a156bb5a&scoped=true"
import script from "./targetAgainstUserTabs.vue?vue&type=script&lang=js"
export * from "./targetAgainstUserTabs.vue?vue&type=script&lang=js"
import style0 from "./targetAgainstUserTabs.vue?vue&type=style&index=0&id=a156bb5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a156bb5a",
  null
  
)

export default component.exports